import { Reveal } from "./Reveal";
import { Sparkles } from "lucide-react";

export const Mission = () => (
  <section id="mission" data-testid="mission-section" className="border-y border-line bg-sand py-24 lg:py-32">
    <div className="mx-auto max-w-4xl px-6 text-center lg:px-10">
      <Reveal>
        <p className="flex items-center justify-center gap-2.5 font-mono text-xs uppercase tracking-[0.25em] text-terracotta">
          <Sparkles className="h-3.5 w-3.5" />
          Our mission
        </p>
        <div
          data-testid="mission-statement"
          className="mt-8 space-y-6 font-serif text-xl font-medium leading-relaxed tracking-tight text-walnut sm:text-2xl"
        >
          <p>
            At Quarterly Pulse, our mission is to help companies build a culture
            people feel part of, not just read about. Culture takes shape in
            everyday moments: whose work gets recognized, how people support one
            another, and whether words turn into action. Those moments shape how
            teams work and what a company becomes.
          </p>
          <p>
            We turn company updates, team wins, and employee feedback into clear
            communication that keeps people connected to each other and to the
            work ahead. By making contributions visible and next steps clear, we
            help teams build trust, share purpose, and put their values into
            practice.
          </p>
        </div>
        <img
          src="/logo.jpg"
          alt="The Quarterly Pulse logo"
          data-testid="mission-logo"
          className="mx-auto mt-12 h-28 w-28 rounded-full border border-walnut/15 object-cover shadow-[0_16px_40px_rgba(42,32,28,0.15)]"
        />
      </Reveal>
    </div>
  </section>
);
